export default __webpack_public_path__ + "static/media/imageOne.0a32677f.svg";